<template>
    <FieldRenderer
        v-for="field in withOutHiddenFields"
        :key="field.id"
        :field="field"
        v-model="formData[field.id]"
        :v$="v$"
    />

    <div class="d-flex justify-content-end">
        <button type="submit" class="main-button" :disabled="status.submitting" @click="handleSubmit">
          <div v-if="status.submitting" class="ms-2">
            <div class="spinner-border spinner-border-sm" style="color: white" role="status"></div>
          </div>
          <span v-else>{{ sendBtnLabel }}</span>
        </button>
    </div>
</template>

<script>
import validations from "./validations.js";
import FieldRenderer from "./FieldRenderer.vue";
import useVuelidate from "@vuelidate/core";
import 'maz-ui/css/main.css';

export default {
    inject: ['axios', 'locale'],
    mixins: [validations],
    components: { FieldRenderer },

    setup() {
        return { v$: useVuelidate('contact-form') };
    },

    data: () => ({
        form: {},
        formData: {},
        status: {
            mount: false,
            submitting: false
        },
        translations: {
            formMessages: {
                success: {
                    en: { title: "Success!", text: "Your message has been sent successfully." },
                    es: { title: "¡Éxito!", text: "Tu mensaje ha sido enviado correctamente." }
                },
                error: {
                    en: { title: "Oops...", text: "Something went wrong submitting your message. Please try again later." },
                    es: { title: "¡Ups!", text: "Algo salió mal al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde." }
                }
            }
        }
    }),

    computed: {
        sendBtnLabel() {
            let labels = {
                es: 'Enviar',
                en: 'Submit'
            }

            return labels[this.locale]
        },

        formSlug() {
            let slugs = {
                es: 'formulario-de-contacto',
                en: 'contact-form'
            }
            return slugs[this.locale]
        },

        fields() {
            return this.form?.form_fields || []
        },

        withOutHiddenFields() {
            return this.fields?.filter(f => !f.hidden)
        },

        rules() {
            const rules = {};

            // Loop through all fields to create the validation rules
            this.fields.forEach((field) => {
                if (field.validations?.length > 0) {
                    rules[field.id] = this.generateValidationRules(field)
                }
            });

            return { formData: rules };
        },
    },

    methods: {
        getForm() {
            this.status.mount = true;

            this.axios.get('/forms/' + this.formSlug, {
                params: { locale: this.locale }
            }).then(r => {
                this.form = r.data.data
            }).finally(() => {
                this.status.mount = false;
            })
        },

        async handleSubmit() {
            const isValid = await this.v$.$validate();
            if (isValid) {
                this.submit();
            }
        },

        submit() {
            if (this.status.submitting) return;

            this.status.submitting = true;
            const successTexts = this.translations.formMessages.success[this.locale] || this.translations.formMessages.success.en; // Fallback a inglés
            const errorTexts = this.translations.formMessages.error[this.locale] || this.translations.formMessages.error.en; // Fallback a inglés

            this.axios.post(`/submissions?locale=${this.locale}`, {
                data: {
                    ...this.formData,
                    form_slug: this.form.slug,
                    locale: this.locale
                }
            }).then(() => {
                this.$swal.fire({
                    icon: 'error',
                    title: successTexts.title,
                    text: successTexts.text
                });
                this.formData = {};
            }).catch(() => {
                this.$swal.fire({
                    icon: 'error',
                    title: errorTexts.title,
                    text: errorTexts.text
                })
            }).finally(() => {
                this.status.submitting = false
            })
        }
    },

    validations() {
        return this.rules
    },

    mounted() {
        this.getForm();
    }
}
</script>